import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class StoreProvider {
  private static injector?: Injector;

  constructor(private injector: Injector) {}

  static getStore(): Store {
    if (StoreProvider.injector === undefined) {
      throw new Error('Did not import ErrorModule.');
    }
    return StoreProvider.injector.get(Store);
  }

  init(): void {
    StoreProvider.injector = this.injector;
  }
}
